import React, { useEffect, useState, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import DynamicNFTCard from '../DynamicCard';
import CardPlaceholder from '../NFTCardPlaceholder';
import DynamicCardProfile from './DynamicCardProfile';
import { getUserByAddress } from '../../../hooks/User';
import { getcreatedToken, getDataFromURI } from '../../../hooks/Tokenhook';
import Pagination from '../../Pagination';
import { contractAddress } from '../../../config/BackendUrl';
import { listNFTs } from '../../../hooks/NFTHook';
import { useParams } from 'react-router-dom';

const CreatedAssetProfile = ({ user, address }) => {
    const [nfts, setNfts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0); // Current page
    const [limit, setLimit] = useState(6); // Items per page
    const [pageCount, setPageCount] = useState(0); // Total number of pages
    const [isPagination, setIsPagination] = useState(false); // Whether to show pagination
    const userIds = localStorage.getItem("userId");
    const { walletAddress } = useParams();
    const userAddress = localStorage.getItem("WalletAddress");

    useEffect(() => {
        GetNFT();
    }, [ currentPage]);

    const GetNFT = async () => {
        try {
            const body = {
                page: currentPage + 1,
                limit, creatorAddress: walletAddress === undefined ? userAddress : walletAddress
            }

            await listNFTs(body).then((OwnData) => {
                if (OwnData.success) {
                    const AddIsLikeFlag = OwnData.data.map(item => {
                        const isLike = item.likes.some(like =>
                            like.userId === userIds // Check if the user's ID exists in the likes array
                        );

                        return { ...item, isLike }; // Merge the `isLike` flag into the NFT object
                    });
                    setNfts(AddIsLikeFlag)
                    setPageCount(OwnData.totalPages)
                    setIsPagination(OwnData.totalPages > 1)
                }
                console.log("OwnData", OwnData);
            })
        } catch (error) {
            console.error('Error fetching NFTs:', error);
        } finally {
            setLoading(false);
        }
    };


    const handlePageChange = (selectedItem) => {
        setCurrentPage(selectedItem.selected);
    };
    console.log("LKFmrt", nfts, address);

    return (
        <>
            <div className="row mb-30_reset">
                {loading ? (
                    [...Array(limit)].map((_, index) => (
                        <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                            <CardPlaceholder />
                        </div>
                    ))
                ) : nfts.length > 0 ? (
                    nfts.map((nft, i) => (
                        <div key={nft.tokenId || i} className="col-lg-4 col-md-6 col-sm-12 card-hover-effect">
                            <DynamicCardProfile
                                NFTLink={`/nftdetails/${nft.contractAddress}/${nft._id}`}
                                contractAddress={nft.contractAddress}
                                mediaUrl={nft.imageUri}
                                assetType={nft.assetType}
                                title={nft.title}
                                likes={nft.totalLikes}
                                isLiked={nft.isLike}
                                tokenId={nft.tokenId}
                                isListed={nft.listed}
                                button={walletAddress === undefined ? true : false}
                                buttonMessage={nft.listed ? 'Listed' : "Trade"}
                                nftId={nft._id}
                                isLazy={nft.type === "Lazy Mint" ? true : false}
                            />
                        </div>
                    ))
                ) : (
                    <h3>No NFTs Available</h3>
                )}
            </div>
            {isPagination && (
                <Pagination
                    pageCount={pageCount}
                    onPageChange={handlePageChange}
                    currentPage={currentPage}
                />
            )}
        </>
    );
};

export default CreatedAssetProfile;
